import PersonalProfile from "components/dashboard/Admin/PersonalProfile/PersonalProfile";
import RolesAndPermissions from "components/dashboard/Admin/RolesAndPermissions/RolesAndPermissions";
import StartupProfile from "components/dashboard/Admin/StartupProfile/StartupProfile";
import UserManagement from "components/dashboard/Admin/UserManagement/UserManagement";
import ConversationsTemplates from "components/dashboard/AgentInbox/AgentInboxSettings/ConversationsTemplates/ConversationsTemplates";
import MessageTagging from "components/dashboard/AgentInbox/AgentInboxSettings/MessageTagging/MessageTagging";
import Routing from "components/dashboard/AgentInbox/AgentInboxSettings/Routing/Routing";
import CapsuleSettings from "components/dashboard/KnowledgeBase/CapsuleSettings/CapsuleSettings";
import ProductCapsuleView from "components/dashboard/KnowledgeBase/ProductSetupContainer/ProductCapsuleView/ProductCapsuleView";
import SingleProductView from "components/dashboard/KnowledgeBase/ProductSetupContainer/ProductDashboard/SingleProductView/SingleProductView";
import ProductSetupContainer from "components/dashboard/KnowledgeBase/ProductSetupContainer/ProductSetupContainer";
import Appearance from "components/dashboard/ServiceModule/ChatSettings/Appearance/Appearance";
// import Discovery from "components/dashboard/TrainSAM/SAM/Discovery/Discovery";
import Issues from "components/dashboard/TrainSAM/SAM/Issues/Issues";
import AppIntegrations from "components/dashboard/AgentInbox/AgentInboxSettings/AppIntegrations/AppIntegrations";
import ViewTeam from "components/dashboard/AgentInbox/AgentInboxSettings/Routing/Teams/ViewTeam/ViewTeam";
import IssuesConversations from "components/dashboard/TrainSAM/SAM/Conversations/IssuesConversations/IssuesConversations";
import ConversationView from "components/dashboard/TrainSAM/SAM/Conversations/ConversationView/ConversationView";
import Downtime from "components/dashboard/TrainSAM/Dependency/Downtime/Downtime";
import SolutionSetupContainer from "components/dashboard/KnowledgeBase/SolutionSetupContainer/SolutionSetupContainer";
import ViewSwitches from "components/dashboard/TrainSAM/Dependency/Switches/ViewSwitches/ViewSwitches";
import Switches from "components/dashboard/TrainSAM/Dependency/Switches/Switches";
import DependencyCapsules from "components/dashboard/TrainSAM/Dependency/DependencyCapsules/DependencyCapsules";
import DependencyCapsulesView from "components/dashboard/TrainSAM/Dependency/DependencyCapsules/DependencyCapsulesView/DependencyCapsulesView";
import FormSetup from "components/dashboard/KnowledgeBase/FormSetup/FormSetup";
import FormsPostFormBranchesList from "components/dashboard/KnowledgeBase/FormsPostFormBranchesList/FormsPostFormBranchesList";
import BranchCollectionView from "components/dashboard/TrainSAM/SAM/BranchCollectionView/BranchCollectionView";
import ViewForm from "components/dashboard/KnowledgeBase/ViewForm/ViewForm";
import DowntimeCapsuleBranchView from "components/dashboard/TrainSAM/SAM/DowntimeCapsuleBranchView/DowntimeCapsuleBranchView";
import GeneralDowntimeCollection from "components/dashboard/TrainSAM/Dependency/GeneralDowntimeCollection/GeneralDowntimeCollection";
import ConcludingBranchView from "components/dashboard/KnowledgeBase/form/ConcludingBranchView/ConcludingBranchView";
import InitialBranch from "components/dashboard/ServiceModule/ChatSettings/InitialBranch/InitialBranch";
import AgentInboxTickets from "components/dashboard/AgentInbox/AgentInboxTickets/AgentInboxTickets";
import Analyzer from "components/dashboard/Analyzer/Anaylzer";
import Personas from "components/dashboard/ServiceModule/ChatSettings/Personas/Personas";
import CreatePersona from "components/dashboard/ServiceModule/ChatSettings/Personas/CreatePersona/CreatePersona";
import AgentFollowUp from "components/dashboard/AgentInbox/AgentFollowUp/AgentFollowUp";
import FollowUpTasksView from "components/dashboard/AgentInbox/AgentFollowUp/FollowUpTasksView/FollowUpTasksView";
import ConversationBreakers from "components/dashboard/ServiceModule/ChatSettings/ConversationBreakers/ConversationBreakers";
// import AnalyticsTeamEfficiency from "components/dashboard/Analytics/AnalyticsTeams/AnalyticsTeamEfficiency/AnalyticsTeamEfficiency";
import AnalyticsTeamVolume from "components/dashboard/Analytics/AnalyticsTeams/AnalyticsTeamVolume/AnalyticsTeamVolume";
import AnalyticsTeamCustomer from "components/dashboard/Analytics/AnalyticsTeams/AnalyticsTeamCustomer/AnalyticsTeamCustomer";
import AnalyticsTeamBacklog from "components/dashboard/Analytics/AnalyticsTeams/AnalyticsTeamBacklog/AnalyticsTeamBacklog";
import Reminders from "components/dashboard/ServiceModule/ChatSettings/Reminders/Reminders";
import AnalyticsTSamConversations from "components/dashboard/Analytics/AnalyticsTSam/AnalyticsTSamConversations/AnalyticsTSamConversations";
import AnalyticsTSamCapsules from "components/dashboard/Analytics/AnalyticsTSam/AnalyticsTSamCapsules/AnalyticsTSamCapsules";
import AnalyticsTSamConvoView from "components/dashboard/Analytics/AnalyticsTSam/AnalyticsTSamConversations/AnalyticsTSamConvoView/AnalyticsTSamConvoView";
import PostFormCollections from "components/dashboard/KnowledgeBase/PostFormCollections/PostFormCollections";
import { baseResources, baseResourceActions } from "./enum";
import { CAPSULE_SETTINGS_READ_PERMISSION } from "components/dashboard/KnowledgeBase/CapsuleSettings/permissions";
import { KNOWLEDGE_BASE_READ_PERMISSION } from "components/dashboard/KnowledgeBase/permissions";
import {
    POST_FORM_READ_PERMISSION,
} from "components/dashboard/KnowledgeBase/PostForms/permissions";
import { SERVICE_MODULE_READ_PERMISSION } from "components/dashboard/ServiceModule/permissions";
import { DEPENDENCY_READ_PERMISSION } from "components/dashboard/TrainSAM/Dependency/permissions";
import {
    LLM_CHAT_READ_PERMISSION,
    LLM_DOCUMENTATION_READ_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/LLMDocumentation/permissions";
import {
    INTEGRATIONS_PAGE_ACCESS_PERMISSION,
} from "components/dashboard/AgentInbox/AgentInboxSettings/AppIntegrations/permissions";
import { INBOX_SETTINGS_READ_PERMISSION } from "components/dashboard/AgentInbox/AgentInboxSettings/Routing/permissions";
import {
    USER_CREATE_PERMISSION,
    ROLES_CREATE_PERMISSION,
    WORKSPACE_PROFILE_UPDATE_PERMISSION,
} from "components/dashboard/Admin/permissions";
import { CONVERSATION_LIBRARY_READ_PERMISSION } from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";
import CannedResponses from "components/dashboard/KnowledgeBase/CannedResponses/CannedResponses";
import AnalyticsQAVetTicket from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQAVetTicket/AnalyticsQAVetTicket";
import AnalyticsQAVetAgents from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQAVetAgents/AnalyticsQAVetAgents";
import AnalyticsQAVetAgentsTicket from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQAVetAgents/AnalyticsQAVetAgentsTicket/AnalyticsQAVetAgentsTicket";
import AgentAGuides from "components/dashboard/TrainSAM/Guides/AgentAGuides";
import AgentAViewGuide from "components/dashboard/TrainSAM/Guides/AgentAViewGuide/AgentAViewGuide";
import Scenarios from "components/dashboard/TrainSAM/Scenarios/Scenarios";
import CannedEmailResponses from "components/dashboard/TrainSAM/CannedResponses/CannedEmailResponses/CannedEmailResponses";
import CannedRepliesResponses from "components/dashboard/TrainSAM/CannedResponses/CannedRepliesResponses/CannedRepliesResponses";
import CannedMentionsResponses from "components/dashboard/TrainSAM/CannedResponses/CannedMentionsResponses/CannedMentionsResponses";
import EmailUpdates from "components/dashboard/TrainSAM/Updates/EmailUpdates/EmailUpdates";
import ResponseUpdates from "components/dashboard/TrainSAM/Updates/ResponseUpdates/ResponseUpdates";
import MentionUpdates from "components/dashboard/TrainSAM/Updates/MentionUpdates/MentionUpdates";
import EmailFollowups from "components/dashboard/TrainSAM/Updates/EmailUpdates/EmailFollowups/EmailFollowups";
import ResponseFollowups from "components/dashboard/TrainSAM/Updates/ResponseUpdates/ResponseFollowups/ResponseFollowups";
import MentionFollowups from "components/dashboard/TrainSAM/Updates/MentionUpdates/MentionFollowups/MentionFollowups";
import GuideDowntime from "components/dashboard/TrainSAM/GuideDowntime/GuideDowntime";
import ViewGuideDowntime from "components/dashboard/TrainSAM/GuideDowntime/ViewGuideDowntime/ViewGuideDowntime";
import AnalyticsQAReport from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQAReport/AnalyticsQAReport";
import AnalyticsQAProgress from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQAProgress/AnalyticsQAProgress";
import AnalyticsQATimeline from "components/dashboard/Analytics/AnalyticsQA/AnalyticsQATimeline/AnalyticsQATimeline";
import QaDocumentation from "components/dashboard/TrainSAM/SAM/QaDocumentation/QaDocumentation";
import ChatSamLLM from "components/dashboard/TrainSAM/SAM/ChatSamLLM/ChatSamLLM";
import AccurateAnalyticsTeamEfficiency from "components/dashboard/Analytics/AnalyticsTeams/AnalyticsTeamEfficiency/AccurateAnalyticsTeamEfficiency";

const {
    KB_FORM_SETTING,
    KB_CANNED_RESPONSE,
    KB_AGENT_GUIDE,
    AGENTS_INBOX,
    FOLLOW_UP,
    ANALYTICS,
} = baseResources;

const { READ } = baseResourceActions;

const DefaultView = ({ title }) => (
    <div className='container my-5 mx-4'>
        <h4>{title}</h4>
    </div>
);

const dashboardRoutes = [
    {
        iconName: "people",
        title: "Admin",
        path: "/admin/user-management",
        component: DefaultView,
        accessLevel: [],
        groupAccessLevel: [],
        tabbedRoutes: [
            {
                title: "User Management",
                path: "/admin/user-management",
                component: UserManagement,
                baseResources: USER_CREATE_PERMISSION,
            },
            {
                title: "Personal Profile",
                path: "/admin/personal-profile",
                component: PersonalProfile,
                // Personal profile is always available to authenticated
                // users; there is no seeded permission for it. Omitting
                // baseResources signals "always allowed".
            },
            {
                title: "Roles & Permission",
                path: "/admin/roles-permission",
                component: RolesAndPermissions,
                baseResources: ROLES_CREATE_PERMISSION,
            },
            {
                title: "Start-up Profile",
                path: "/admin/workspace",
                component: StartupProfile,
                baseResources: WORKSPACE_PROFILE_UPDATE_PERMISSION,
            },
        ],
    },
    {
        title: "Knowledge Base",
        path: "/knowledge-base/capsule-settings",
        component: CapsuleSettings,
        iconName: "round-check",
        dropDowns: [
            {
                title: "Capsule Settings",
                path: "/knowledge-base/capsule-settings",
                hide: false,
                component: CapsuleSettings,
                baseResources: CAPSULE_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Product Setup",
                path: "/knowledge-base/product",
                hide: false,
                component: ProductSetupContainer,
                baseResources: KNOWLEDGE_BASE_READ_PERMISSION,
            },
            {
                title: "Product Setup",
                path: "/knowledge-base/product/:productId/capsules",
                component: SingleProductView,
                isExact: false,
                hide: true,
                baseResources: KNOWLEDGE_BASE_READ_PERMISSION,
            },
            {
                title: "Product Setup",
                path: "/knowledge-base/capsule/:productId/:capsuleId",
                hide: true,
                component: ProductCapsuleView,
                baseResources: KNOWLEDGE_BASE_READ_PERMISSION,
            },
            {
                title: "Solution Setup",
                path: "/knowledge-base/solution-setup",
                hide: false,
                component: SolutionSetupContainer,
                baseResources: KNOWLEDGE_BASE_READ_PERMISSION,
            },
            {
                title: "Forms",
                path: "/knowledge-base/forms",
                component: FormsPostFormBranchesList,
                baseResources: [`${READ}_${KB_FORM_SETTING}`],
            },
            {
                title: "Concluding Form Branch",
                path: "/knowledge-base/form/concluding-branch",
                component: ConcludingBranchView,
                hide: true,
                baseResources: [`${READ}_${KB_FORM_SETTING}`],
            },
            {
                title: "Create New Form",
                path: "/knowledge-base/form/new",
                component: FormSetup,
                hide: true,
                baseResources: [`${READ}_${KB_FORM_SETTING}`],
            },
            {
                title: "View Form",
                path: "/knowledge-base/form/:formId",
                component: ViewForm,
                hide: true,
                baseResources: [`${READ}_${KB_FORM_SETTING}`],
            },
            {
                title: "Post Forms",
                path: "/knowledge-base/post-form",
                component: PostFormCollections,
                hide: false,
                baseResources: POST_FORM_READ_PERMISSION,
            },
            {
                title: "Canned Responses",
                path: "/knowledge-base/canned-responses",
                hide: false,
                component: CannedResponses,
                baseResources: [`${READ}_${KB_CANNED_RESPONSE}`],
            },
        ],
    },
    {
        iconName: "agent-inbox",
        title: "Agent Inbox",
        path: "/agents-inbox/settings/tickets-routing",
        component: Routing,
        tabbedRoutes: [
            {
                title: "Routing",
                path: "/agents-inbox/settings/tickets-routing",
                component: Routing,
                baseResources: INBOX_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Conversations",
                path: "/agents-inbox/settings/conversations",
                component: ConversationsTemplates,
                baseResources: INBOX_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Message Tagging",
                path: "/agents-inbox/settings/message-tagging",
                component: MessageTagging,
                baseResources: INBOX_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Integrations",
                path: "/agents-inbox/settings/integrations",
                component: AppIntegrations,
                baseResources: INTEGRATIONS_PAGE_ACCESS_PERMISSION,
            },
        ],
        dropDowns: [
            {
                title: "Setting",
                path: "/agents-inbox/settings/tickets-routing",
                hide: false,
                component: Routing,
                baseResources: INBOX_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Inbox",
                path: "/agents-inbox/tickets",
                hide: false,
                component: AgentInboxTickets,
                baseResources: [`${READ}_${AGENTS_INBOX}`],
            },
            {
                title: "Agent Inbox",
                path: "/agents-inbox/settings/teams/:teamId",
                hide: true,
                component: ViewTeam,
                baseResources: INBOX_SETTINGS_READ_PERMISSION,
            },
            {
                title: "Follow Up",
                path: "/agents-inbox/follow-up/:followUpId",
                hide: true,
                component: FollowUpTasksView,
                baseResources: [`${READ}_${FOLLOW_UP}`],
            },

            {
                title: "Follow Up",
                path: "/agents-inbox/follow-up",
                component: AgentFollowUp,
                baseResources: [`${READ}_${FOLLOW_UP}`],
            },
        ],
    },
    {
        title: "Training SAM",
        path: "/t-sam/issues",
        iconName: "train-sam",
        tabbedRoutes: [
            {
                title: "Issues",
                path: "/t-sam/issues",
                component: Issues,
                baseResources: CONVERSATION_LIBRARY_READ_PERMISSION,
            },
            // {
            //     title: "Discovery",
            //     path: "/t-sam/discovery",
            //     component: Discovery,
            //     baseResources: [`${READ}_${KB_CONVERSATION_LIBRARY}`],
            // },
            {
                title: "Conversations",
                path: "/t-sam/conversations",
                isExact: true,
                component: IssuesConversations,
                baseResources: CONVERSATION_LIBRARY_READ_PERMISSION,
            },
        ],
        dropDowns: [
            {
                title: "SAM",
                path: "/t-sam/issues",
                hide: false,
                component: Issues,
                baseResources: CONVERSATION_LIBRARY_READ_PERMISSION,
            },
            {
                title: "Downtime Capsule Collection View",
                path: "/t-sam/downtime-collection/:capsuleClassId/view/:capsuleEntryId",
                component: DowntimeCapsuleBranchView,
                hide: true,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "Branch Collection View",
                path: "/t-sam/branch-collection/:branchCollectionId/view",
                component: BranchCollectionView,
                hide: true,
                baseResources: [
                    ...KNOWLEDGE_BASE_READ_PERMISSION,
                    ...DEPENDENCY_READ_PERMISSION,
                ],
            },
            {
                title: "View Conversation",
                path: "/t-sam/conversations/:conversationId/view-conversation",
                hide: true,
                component: ConversationView,
                baseResources: CONVERSATION_LIBRARY_READ_PERMISSION,
            },

            {
                title: "Agent Assistance",
                path: "/t-sam/agent-assistance",
                component: AgentAGuides,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },
            {
                title: "Agent Assistance",
                path: "/t-sam/guide/view/*",
                component: AgentAViewGuide,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },
            {
                title: "Scenarios",
                path: "/t-sam/scenarios",
                component: Scenarios,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },

            {
                title: "Updates",
                path: "/t-sam/updates/email/view/*",
                component: EmailFollowups,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },
            {
                title: "Updates",
                path: "/t-sam/updates/email",
                component: EmailUpdates,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },
            {
                title: "Updates",
                path: "/t-sam/updates/response/view/*",
                component: ResponseFollowups,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },
            {
                title: "Updates",
                path: "/t-sam/updates/response",
                component: ResponseUpdates,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },

            {
                title: "Updates",
                path: "/t-sam/updates/mention/view/*",
                component: MentionFollowups,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },

            {
                title: "Updates",
                path: "/t-sam/updates/mention",
                component: MentionUpdates,
                hide: true,
                baseResources: [`${READ}_${KB_AGENT_GUIDE}`],
            },

            {
                title: "Responses",
                path: "/t-sam/responses/emails",
                component: CannedEmailResponses,
                baseResources: [`${READ}_${KB_CANNED_RESPONSE}`],
            },
            {
                title: "Responses",
                path: "/t-sam/responses/replies",
                component: CannedRepliesResponses,
                hide: true,
                baseResources: [`${READ}_${KB_CANNED_RESPONSE}`],
            },
            {
                title: "Responses",
                path: "/t-sam/responses/mentions",
                component: CannedMentionsResponses,
                hide: true,
                baseResources: [`${READ}_${KB_CANNED_RESPONSE}`],
            },
            {
                title: "View Guide Downtime",
                path: "/t-sam/guide-downtime/view/*/*",
                component: ViewGuideDowntime,
                hide: true,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "LLM Documentation",
                path: "/t-sam/llm-documentation",
                component: QaDocumentation,
                baseResources: LLM_DOCUMENTATION_READ_PERMISSION,
            },
            {
                title: "LLM Chat",
                path: "/t-sam/llm-chat",
                component: ChatSamLLM,
                baseResources: LLM_CHAT_READ_PERMISSION,
            }
        ],
    },
    {
        title: "Dependency",
        path: "/dependency/switches",
        iconName: "dependency",
        component: Switches,
        tabbedRoutes: [
            {
                title: "Switches",
                path: "/dependency/switches",
                component: Switches,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },

            {
                title: "Downtime branches",
                path: "/dependency/downtime-branches",
                component: Downtime,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "Downtime Guides",
                path: "/dependency/downtime-guides",
                component: GuideDowntime,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "Capsules",
                path: "/dependency/capsules",
                component: DependencyCapsules,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "General Downtime Collections",
                path: "/dependency/general-downtime-collection",
                component: GeneralDowntimeCollection,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
        ],
        dropDowns: [
            {
                title: "View Switches",
                path: "/dependency/view-switches/:switchType",
                component: ViewSwitches,
                hide: true,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
            {
                title: "View Capsules",
                path: "/dependency/view-capsules/:capsuleClassId/:capsuleType",
                component: DependencyCapsulesView,
                hide: true,
                baseResources: DEPENDENCY_READ_PERMISSION,
            },
        ],
    },
    // {
    //     title: "Help Center",
    //     path: "/help-center",
    //     iconName: "help-center",
    //     component: Other,
    // },
    {
        title: "Service Module",
        path: "/service-module/appearance",
        iconName: "service-module",
        tabbedRoutes: [
            {
                title: "Appearance",
                path: "/service-module/appearance",
                component: Appearance,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
            {
                title: "Initial Branch",
                path: "/service-module/initial-branch",
                component: InitialBranch,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
            {
                title: "Personas",
                path: "/service-module/personas",
                component: Personas,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
            {
                title: "Conversation Breakers",
                path: "/service-module/conversation-breakers",
                component: ConversationBreakers,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
            {
                title: "Reminders",
                path: "/service-module/reminders",
                component: Reminders,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
        ],
        dropDowns: [
            {
                title: "New Persona",
                path: "/service-module/:actionType/persona",
                component: CreatePersona,
                hide: true,
                baseResources: SERVICE_MODULE_READ_PERMISSION,
            },
        ],
    },
    {
        title: "Analyzer",
        path: "/analyzer",
        iconName: "help-center",
        component: Analyzer,
        baseResources: INBOX_SETTINGS_READ_PERMISSION,
    },
    {
        iconName: "analytics",
        title: "Analytics",
        path: "/analytics/teams/efficiency",
        component: AccurateAnalyticsTeamEfficiency,
        baseResources: [`${READ}_${ANALYTICS}`],
        tabbedRoutes: [
            {
                title: "Efficiency",
                path: "/analytics/teams/efficiency",
                component: AccurateAnalyticsTeamEfficiency,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Volume",
                path: "/analytics/teams/volume",
                component: AnalyticsTeamVolume,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Customer Satisfaction",
                path: "/analytics/teams/customer-satisfaction",
                component: AnalyticsTeamCustomer,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Backlog",
                path: "/analytics/teams/backlog",
                component: AnalyticsTeamBacklog,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
        ],
        dropDowns: [
            {
                title: "Teams",
                path: "/analytics/teams/efficiency",
                hide: false,
                component: AccurateAnalyticsTeamEfficiency,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Conversation Analytics",
                path: "/analytics/t-sam/conversation/:conversationId/activity",
                hide: true,
                isExact: false,
                component: AnalyticsTSamConvoView,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Training SAM",
                path: "/analytics/t-sam/conversations",
                hide: false,
                component: AnalyticsTSamConversations,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Capsules",
                path: "/analytics/t-sam/capsules",
                hide: true,
                component: AnalyticsTSamCapsules,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "QA",
                path: "/analytics/qa/vet-tickets",
                hide: true,
                component: AnalyticsQAVetTicket,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Vet Agents",
                path: "/analytics/qa/vet-agents/ticket/*",
                hide: true,
                component: AnalyticsQAVetAgentsTicket,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Vet Agents",
                path: "/analytics/qa/vet-agents/*",
                hide: true,
                component: AnalyticsQAVetAgents,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "QA report",
                path: "/analytics/qa/report",
                hide: true,
                component: AnalyticsQAReport,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Quality timeline",
                path: "/analytics/qa/progress/*",
                hide: true,
                component: AnalyticsQATimeline,
                baseResources: [`${READ}_${ANALYTICS}`],
            },
            {
                title: "Quality progress",
                path: "/analytics/qa/progress",
                hide: true,
                component: AnalyticsQAProgress,
                baseResources: [`${READ}_${ANALYTICS}`],
            },

            // {
            //     title: "Knowledge Base",
            //     path: "/analytics/knowledge-base",
            //     component: "",
            //     hide: false,
            // },
            // {
            //     title: "Training SAM",
            //     path: "/analytics/train-sam",
            //     component: "",
            //     hide: false,
            // },
            // {
            //     title: "Help Center",
            //     path: "/analytics/help-center",
            //     component: "",
            //     hide: false,
            // },
        ],
    },
];

export default dashboardRoutes;
